<template>
  <div :class="['ms-form ms-form--narrow', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomSelect
          :options="roomsOptions"
          label="Комната"
          :required="true"
          optionValueKey="room_id"
          optionLabelKey="room_name"
          :value="this.formData.room_id || ''"
          @change="(value) => {
            onChange('room_id', value);
            if (value) fetchTKWorkSets(this.formData.client_request_id, value);
          }"
        />

        <CustomSelect
          :options="workSetsOptions"
          label="Конструктив"
          :required="true"
          optionValueKey="work_set_id"
          optionLabelKey="work_set_name"
          :value="this.formData.work_set_id || ''"
          @change="(value) => onChange('work_set_id', value)"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import { getTKRooms, getTKWorkSets } from '@/views/ClientRequests/remontDS/dsCreationTemplates/changeTextConstructor/services'

export default {
  name: "text-constructor-works",
  components: { CustomCheckbox, CustomModalFooter, CustomInput, CustomSelect },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        client_request_id: this.data?.body?.client_request_id || '',
        ds_id: this.data?.body?.ds_id || '',
        room_id: this.data?.body?.room_id || '',
        work_set_id: this.data?.body?.work_set_id || '',
      },
      roomsOptions: [],
      workSetsOptions: [],
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value;

      if (key === 'room_id') {
        if (!value) {
          this.formData.work_set_id = '';
          this.workSetsOptions = [];
        }
      }
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
    async fetchRooms(client_request_id) {
      this.roomsOptions = await getTKRooms(client_request_id);
    },
    async fetchTKWorkSets(client_request_id, room_id) {
      this.workSetsOptions = await getTKWorkSets(client_request_id, room_id, this.data?.body?.ds_id);
    },
  },
  mounted() {
    this.fetchRooms(this.formData.client_request_id);
  }
}
</script>
